import { ReminderCampaignCommunicationInformationResponse } from '../../api-models';
import { ReminderCampaignCommunicationInformation } from '../../types/campaigns.type';
import { HTTPMethod } from '../../types/enums';
import { AdapterInterface } from '../../types/global';
import BaseAdapter from './baseAdapter';

export default class PostReminderCampaignCommunicationInformation extends BaseAdapter<ReminderCampaignCommunicationInformationResponse> implements AdapterInterface {
  rawResponse: ReminderCampaignCommunicationInformationResponse;

  async adaptResponse(request: { id: number }): Promise<ReminderCampaignCommunicationInformation> {
    await this.fetchApiResponse('/api/reminder-campaign-communication-information', HTTPMethod.Post, request);
    return {
      campaignCommunicationIdString: this.rawResponse.campaign_communication_id.toString(),
      name: this.rawResponse.name,
      benefitName: this.rawResponse.benefit_name,
      initialSnapshot: this.rawResponse.initial_snapshot,
      latestSnapshot: this.rawResponse.latest_snapshot,
      numberOfInitialHouseholds: this.rawResponse.number_of_initial_households,
      numberOfEligibleHouseholds: this.rawResponse.number_of_eligible_households,
    };
  }
}
